export default "__VITE_ASSET__179fa700__$_?component__"